export default {
  SET_DOMAINS_PROPS(state, props) {
    state.props = props;
  },
};
